import Mousewheel from 'jquery-mousewheel'
Mousewheel($)

let Lightbox = Vue.component('lightbox', {
	data() {
		return {
			$anchors: null,
			$slideshow: null,
			length: 0,
			images: [],
			show: false,
			isSlicked: false,
			captions: [],
			mousewheelTimer: 0,
			blockMouseWheelEvents: false,
			currentCaption: '',
			anchorStyle: {
				opacity: 0
			},
			slideshowStyle: {
				opacity: 0
			}
		}
	},
	methods: {
		init: function(i) {
			let index = i || 0
			this.$anchors.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				vertical: true,
				initialSlide: index,
				arrows: false,
				accessibility: true,
				asNavFor: '#lightbox',
				focusOnSelect: true
			})
			this.$slideshow.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				vertical: true,
				initialSlide: index,
				verticalSwiping: true,
				prevArrow: $('.slick-next'),
				nextArrow: $('.slick-prev'),
				accessibility: true,
				focusOnSelect: true
			})
			this.$slideshow.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
				this.$anchors.slick('slickGoTo', nextSlide)
				this.currentCaption = this.captions[nextSlide] || ''
			})
			$(document).on('keydown', (e) => {
				if(e.keyCode == 38) {
                    this.$slideshow.slick('slickPrev');
                }
                if(e.keyCode == 40) {
                    this.$slideshow.slick('slickNext');
                }
			})
			this.currentCaption = this.captions[0]
			this.isSlicked = true
			this.show = true
		},
		close: function() {
			this.show = false
			// this.anchorStyle.opacity = 0
			// this.slideshowStyle.opacity = 0

		},
		clear: function() {
			$(document).off('keydown', (e) => {
				if(e.keyCode == 37) {
                    this.$slideshow.slick('slickPrev');
                }
                if(e.keyCode == 39) {
                    this.$slideshow.slick('slickNext');
                }
			})
			$(this.$slideshow).slick('unslick')
			$(this.$anchors).slick('unslick')
			this.$anchors.empty()
			this.$slideshow.empty()
			this.isSlicked = false
		},
		open: function(array, index) {
			if (this.isSlicked) this.clear()
			this.captions = []
			for (var i = 0; i < array.length; i++) {
				let html = '<li><img src="' + array[i].src + '"></li>'
				this.captions.push(array[i].caption)
				$(this.$anchors).append(html)
				$(this.$slideshow).append(html)
			}
			this.$nextTick(() => {
				this.init(index)
			})
		}
	},
	mounted() {
		let self = this;
		let $self = $(self.$el)
		this.$anchors = $self.find('#lightbox-anchors')
		this.$slideshow = $self.children('#lightbox')
		this.$slideshow.mousewheel(function(e) {

			e.preventDefault()

			if (self.blockMouseWheelEvents) {
				return
			}

			setTimeout(() => {
				self.blockMouseWheelEvents = false
			}, 1000);

			self.blockMouseWheelEvents = true

			if (e.deltaY < 0) {
				$(this).slick('slickNext')
			} else {
				$(this).slick('slickPrev')
			}

		})

		// this.$anchors.on('init', (e) => {
		// 	this.anchorStyle.opacity = 1
		// })
		// this.$slideshow.on('init', (e) => {
		// 	this.slideshowStyle.opacity = 1
		// })

	},
	template: `
	<div class="lightbox" v-show="show">
		<div class="slick-next">&#8613;</div>
		<div class="slick-prev">&#8615;</div>
		<div @click="close" class="lightbox-close">&times;</div>
		<div class="lightbox-anchors-container">
			<ul class="lightbox-anchors" id="lightbox-anchors"></ul>
		</div>
		<ul class="lightbox-slideshow" id="lightbox"></ul>
		<p class="lightbox-caption">{{ this.currentCaption }}</p>
	</div>`
})

export default Lightbox
